import Utils from '../untils';
import Vue from 'vue';
import router from '../router'
import vueResource from 'vue-resource';
Vue.use(vueResource, router);

/*处理超时异常*/
Vue.http.interceptors.push((request, next) => {
  let timeout;
  if(request.url?(request.url.split('?')[0] == 'https://maps.googleapis.com/maps/api/geocode/json'):false) {

  } else if (request.url?(request.url.split('?')[0] == 'https://www.googleapis.com/geolocation/v1/geolocate'):false) {

  } else {
        Vue.http.headers.common = {webType:'store',token:Utils.loadLocal2('token')}
  }
  // 這裡改用 _timeout
  if (request._timeout) {
    timeout = setTimeout(() => {
      //自定义响应体 status:408,statustext:"请求超时"，并返回给下下边的next
      next(request.respondWith(request.body, {
        status: 408,
        statusText: '请求超时'
      }));
    }, request._timeout);
  }
  next((response) => {
    var newToken = response.headers && response.headers.get ? response.headers.get('token') : null;
    if (newToken) {
      var store = require('../store').default;
      store.commit('settoken', newToken);
      localStorage.setItem('token', newToken);
    }
    return response;
  })
});

export const request = (params, showLoding) => {
  let resp;
  const p = new Promise((resolve, reject) => {
    Vue.http.post(config.site + params.action, params, {
      _timeout: 20000,credentials: false,emulateJSON:true
    }).then(res => {
      packageRespon(res, resolve);
    }, function (err) {
      packageError(err)
    });
  }).catch(err => {
    packageCatch(err);
    return null;
  });
  return p;
};

// get请求
export const requestget = (params) => {
  let resp;
  /* 开始请求a*/
  const p = new Promise((resolve, reject) => {
    Vue.http.get(config.site + params.action, {
      _timeout: 20000,emulateJSON:true
    }).then(res => {
      packageRespon(res, resolve);
    }, function (err) {
      packageError(err)
    });
  }).catch(err => {
    packageCatch(err);
    return null;
  });
  return p;
};


export const requestbody = (params, showLoding) => {
  let resp;
  const p = new Promise((resolve, reject) => {
    Vue.http.post(config.site + params.action,
      JSON.stringify(params),
      {
      _timeout: 20000,emulateJSON:true
    }).then(res => {
      packageRespon(res, resolve);
    }, function (err) {
      packageError(err)
    });
  }).catch(err => {
    packageCatch(err);
    return null;
  });
  return p;
};

//post请求
export const requestbodys = (params, showLoding) => {
  let resp;
  const p = new Promise((resolve, reject) => {
    Vue.http.post(config.site + params.action,
      JSON.stringify(params),
      {
      _timeout: 20000,emulateJSON:true,
      'headers': {
        'Content-Type':'application/json'
      }
    }).then(res => {
      packageRespon(res, resolve);
    }, function (err) {
      packageError(err)
    });
  }).catch(err => {
    packageCatch(err);
    return null;
  });
  return p;
};

//put请求
export const requestput = (params, showLoding) => {
  let resp;
  const p = new Promise((resolve, reject) => {
    Vue.http.put(config.site + params.action,
      JSON.stringify(params),
      {
      _timeout: 20000,emulateJSON:true,
      'headers': {
        'Content-Type':'application/json'
      }
    }).then(res => {
      packageRespon(res, resolve);
    }, function (err) {
      packageError(err)
    });
  }).catch(err => {
    packageCatch(err);
    return null;
  });
  return p;
};

//del请求
export const requestdel = (params, showLoding) => {
  let resp;
  const p = new Promise((resolve, reject) => {
    Vue.http.delete(config.site + params.action,{params:params}, {
      _timeout: 20000,emulateJSON:true
    }).then(res => {
      packageRespon(res, resolve);
    }, function (err) {
      packageError(err)
    });
  }).catch(err => {
    packageCatch(err);
    return null;
  });
  return p;
};

/*请求配置*/
export const config = {
  site: process.env.VUE_APP_ROOT_API, //
  signKey: 'unifi'
};

export const YWID = {
  cookIn: '100'
};

export const Keys = {
  USER: 'u0',
  USERID: 'u1',
  LOCATION: 'l0',
  LAT: 'l1',
  LNG: 'l2',
  UNREADNUM: 'u3',
  CODE: 'c0'
};

function packageParams(params) {
  /*必须参数*/
  params = Utils.filterNull(params);
  let xmlstr = '';
  if (params) {
    xmlstr = '{';
    let f = true;
    for (let it in params) {
      if (f) {
        xmlstr += '"' + it + '":"' + params[it] + '"';
        f = false;
      } else {
        xmlstr += ',"' + it + '":"' + params[it] + '"';
      }
    }
    xmlstr += '}';
  }
  return params
}

//拦截
function packageRespon(res, resolve) {
  if (res.body.code == 70002) {
    Utils.alert('','Password Error','error');
  }  else if (res.body.code == 50001) {
    Utils.alert('','Verification Code Error','error');
    //token过期,返回首页
  }  else if (res.body.code == 90000) {
    router.push({path: '/login'+'?'+Math.random()})
  }  else if (res.body.code == 90001) {
    router.push({path: '/login'+'?'+Math.random()})
  }  else if (res.body.code == 90002) {
    router.push({path: '/login'+'?'+Math.random()})
  }
  else if (res.body.code == 8903) {
    router.push({path: '/login'+'?'+Math.random()})
    Utils.alert('',res.body.message,'error');
  }
  else if(res.body.code==8901){
      router.push({name:'login',params:{err:2}})
      // resolve(res.body);
  }else if(res.body.code==8902){
      router.push({name:'login',params:{err:1}})
      // resolve(res.body);
  }
  else {
    resolve(res.body);
  }
}


//对应状态的响应
function packageError(err) {
  if (!err.ok) {
    switch (err.status) {
      case 408:
        Utils.alert('','Unable to connect to the server.','error');
        break;
      default:
        Utils.alert('','Unable to connect to the server.','error');
        break
    }
  }
}

function packageCatch(err) {
  if (err && err.msg) {
    Utils.alert('','Unable to connect to the server.','error');
  } else {
    Utils.alert('','Unable to connect to the server.','error');
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js